import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AuthService } from '../core/auth-service';
import { TaskViewTypes } from './enums/task-view-types';
import { TaskListAuthComponent } from './task-list-auth/task-list-auth.component';
import { TaskListUserComponent } from './task-list-user/task-list-user.component';
import { BuyerService } from '../services/buyer.service';
import { take, takeUntil, tap } from 'rxjs/operators';
import { Buyer } from '../models/buyer.model';
import { Subject } from 'rxjs';
import { PagerService } from '../pager/services/pager.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TaskListRetrieveComponent } from './task-list-retrieve/task-list-retrieve.component';
import { VrmInputModalComponent } from '../search-vrm/vrm-input-modal/vrm-input-modal.component';
import { SignalREventService } from '../services/signal-revent.service';
import { ActivatedRoute } from '@angular/router';
import { TaskListBranchComponent } from './task-list-branch/task-list-branch.component';
import { Site } from '../diary/models/site.model';
import { NavigationHistoryService } from '../core/navigation-history.service';

@Component({
  selector: 'app-task-list',
  templateUrl: './task-list.component.html',
  styleUrls: ['./task-list.component.scss']
})
export class TaskListComponent implements OnInit, OnDestroy, AfterViewInit {
  view: TaskViewTypes;
  loading: boolean;
  taskView = TaskViewTypes;
  username: string;
  currentTime: number;
  refreshDate: NodeJS.Timeout;
  hasRegionRoles: boolean;
  public buyerObject: Buyer;
  currentView: string;
  vrm: string;
  destroy$ = new Subject();
  initialTaskId: number;
  current_site: Site;

  constructor(
    private buyerService: BuyerService,
    private authService: AuthService,
    private pagerService: PagerService,
    private modalService: NgbModal,
    private signalREventService: SignalREventService,
    private route: ActivatedRoute,
    private navigationHistory: NavigationHistoryService
  ) { }


  @ViewChild(TaskListAuthComponent) taskListAuthComponent: TaskListAuthComponent;
  @ViewChild(TaskListUserComponent) taskListUserComponent: TaskListUserComponent;
  @ViewChild(TaskListRetrieveComponent, { static: false }) taskListRetrieveComponent: TaskListRetrieveComponent;
  @ViewChild(TaskListBranchComponent) taskListBranchComponent: TaskListBranchComponent;


  ngOnInit(): void {
    this.loading = true;
    this.username = this.authService.getUser()?.username.split('@')[0].toLowerCase();
    this.currentTime = Date.now();
    this.route.queryParamMap
      .pipe(
        tap((params) => {
          this.initialTaskId = parseInt(params.get('nId'), 10);
        }),
        take(1)
      )
      .subscribe();
  }

  ngOnDestroy() {
    clearInterval(this.refreshDate);
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  async ngAfterViewInit() {
    this.buyerObject = await this.buyerService.getCurrentBuyer();
    const regionIds = this.getRegionsIds();
    const id = this.navigationHistory.getId();
    const taskType = this.navigationHistory.getTaskView();

    if (id > 0) {
      if (taskType == TaskViewTypes.User) {
        this.setView(TaskViewTypes.User);
      } else if (taskType == TaskViewTypes.Auth) {
        this.setView(TaskViewTypes.Auth);
      } else if (taskType == TaskViewTypes.Branch) {
        this.setView(TaskViewTypes.Branch);
      }
    } else if (id == 0) {
      if (this.initialTaskId) {
        this.setView(TaskViewTypes.User);
      } else if (regionIds.length > 0) {
        this.setView(TaskViewTypes.Auth);
      } else {
        this.setView(TaskViewTypes.User);
      }
    }


    if (regionIds.length > 0) {
      this.hasRegionRoles = true;
    } else {
      this.hasRegionRoles = false;
    }
    this.signalREventService.authorizationRequestReceived$.pipe(takeUntil(this.destroy$)).subscribe((authorizationRequestNotification) => {
      if (this.taskListAuthComponent // Component needs to exist before we can refresh the data
        && regionIds.includes(authorizationRequestNotification.regionId.toString())) {
        this.refreshData();
      }
    });
    this.refreshDate = setInterval(() => {
      this.currentTime = Date.now();
    }, 1000);
  }

  getRegionsIds() {
    const employeeRegRoles = this.buyerObject.employee.employeeRegionRoles;
    const regionIds = new Array<string>();
    if (employeeRegRoles !== null && employeeRegRoles !== undefined) {
      employeeRegRoles.forEach(element => {
        if (element.roleId === 6) {
          regionIds.push(element.regionId.toString());
        }
      });
      return regionIds;
    }
  }

  setView(view: TaskViewTypes) {
    this.navigationHistory.setTaskView(view);
    this.pagerService.setPageNumber(1);
    this.view = view;
  }

  refreshData() {
    if (this.view === TaskViewTypes.User) {
      this.taskListUserComponent.retrieveTasks();
    } else if (this.view === TaskViewTypes.Auth) {
      const regionIds = this.getRegionsIds();
      this.taskListAuthComponent.getRegionFilterForUsername();
      this.taskListAuthComponent.retrieveAuthTasks();
      this.taskListAuthComponent.getRegionsForUser(regionIds);
    } else if (this.view === TaskViewTypes.Retrieve) {
      this.taskListRetrieveComponent.retrieveTasks();
    } else if (this.view === TaskViewTypes.Branch) {
      this.current_site = this.buyerService.getCurrentSiteFromStorage();
      if (this.current_site) {
        this.taskListBranchComponent.retrieveTasks(this.current_site.siteId);
      }
    }
  }

  searchVrm() {
    const modalRef = this.modalService.open(VrmInputModalComponent, {
      keyboard: false,
      backdrop: 'static',
      centered: true,
      size: 'md'
    });
    modalRef.result.then(
      (result) => {
        this.vrm = result;
        this.setView(TaskViewTypes.Retrieve);
      },
      () => { }
    );
  }
}
